// Site Configuration - Update your personal information here
export const siteConfig = {
  // Personal Information
  agentName: "Raj Manda",
  tagline: "Licensed Realtor",
  tagline2: "FL License#: BK9876543 / CA DRE#: 02251457",
  
  // Contact Information
  phone: "(315) 877-5699",
  email: "raj.manda@gmail.com",
  
  // California Office
  californiaOffice: {
    address: "5256 South Mission Road, Suite #905",
    city: "Bonsall",
    state: "CA",
    zip: "92003",
    region: "Northern CA",
    mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d100939.99243632812!2d-122.4194!3d37.7749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA!5e0!3m2!1sen!2sus!4v1234567890"
  },
  
  // Florida Office
  floridaOffice: {
    address: "8001 SW 24th St",
    city: "Miami",
    state: "FL",
    zip: "33155",
    region: "Central Florida/Tampa, FL",
    mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d112185.48249081745!2d-81.3792!3d28.5383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e773d8fecdbc77%3A0xac3b2063ca5bf9e!2sOrlando%2C%20FL!5e0!3m2!1sen!2sus!4v1234567890"
  },
  
  // Combined Location Display
  locations: "Bay Area/Northern CA & Central Florida/Tampa, FL",
  
  // License Information
  californiaLicense: "CA DRE#: 02251457",
  floridaLicense: "FL License#: BK3453341",
  
  // Social Media Links
  socialMedia: {
    linkedin: "https://linkedin.com/in/rajmanda",
    instagram: "https://instagram.com/rajmanda",
    youtube: "https://youtube.com/@rajmanda_realtor"
  },
  
  // Business Hours
  businessHours: "Mon-Sat: 9am-7pm",
  
  // Service Areas
  serviceAreas: {
    california: ["San Francisco Bay Area", "Silicon Valley", "Sacramento", "Manteca", "Elk Grove", "San Diego"],
    florida: ["Orlando", "Tampa", "Miami", "Parrish", "Sarasota"]
  },
  
  // Experience
  yearsOfExperience: "5+",
  
  // Website Meta
  siteTitle: "Raj Manda Real Estate - Florida & California Realtor",
  siteDescription: "Licensed Realtor serving California and Florida. Find your dream home with expert guidance and local market knowledge.",
  
  // Site Status
  showUnderConstructionBanner: true,  // Set to false to hide banner
  
  // Copyright
  copyrightYear: new Date().getFullYear(),
  companyName: "RAJMANDA LLC"
};
